import React from "react";
import {Button} from "@aws-amplify/ui-react";
import OnlineAvailabilityDialog from "../dialogs/OnlineAvailabilityDialog";
import {COLOR_GRAY, COLOR_VARIATION_ERROR, COLOR_VARIATION_SUCCESS} from "../../commons/enums/ColorEnums";
import {HiOutlineStatusOnline} from "react-icons/hi";
import Tooltip from "@mui/material/Tooltip";
import {deserialize} from "../../commons/Utils/SerializationUtils";

const MS_PER_DAY = 24 * 60 * 60 * 1000;
const MS_PER_WEEK = 7 * MS_PER_DAY;

const checkOnline = function(events) {

    const now = new Date();
    const nowTime = now.getTime();

    return events.some(({ start, end }) => {
        const startTime = new Date(start).getTime();
        const endTime = new Date(end).getTime();
        const duration = endTime - startTime;

        if (now < startTime) {
            console.error("'now' should always be after onlineAvailability events, since the events are from a fixed week in the past", now, events)
            return false;
        }

        const delta = (nowTime - startTime) % MS_PER_WEEK;

        return delta < duration;
    });
}

const OnlineAvailabilityButton = function(props) {

    const {user} = props

    const [tooltipOpen, setTooltipOpen] = React.useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);

    const onlineAvailabilityEvents = deserialize(user.onlineAvailability, []);

    const isCurrentlyAvailable = checkOnline(onlineAvailabilityEvents);
    const isConfigured = onlineAvailabilityEvents && onlineAvailabilityEvents.length > 0;

    const tooltip = isConfigured ? (isCurrentlyAvailable ?
        "User is online - click to check the availability" :
        "User is offline - click to check the availability") : "User has not configured online availability";

    const color = isConfigured ? (isCurrentlyAvailable ? COLOR_VARIATION_SUCCESS : COLOR_VARIATION_ERROR)
        : COLOR_GRAY;

    return (
        <Tooltip title={tooltip} placement={"top"} open={tooltipOpen}>
                        <span>
            <Button size={"medium"} variation={"link"}
                    onClick={() => {
                        if(isConfigured) {
                            setTooltipOpen(false);
                            setOpenDialog(true);
                        }
                    }}
                        onMouseEnter={() => setTooltipOpen(true)}
                        onMouseLeave={() => setTooltipOpen(false)}
            >
                <HiOutlineStatusOnline color={color} />
            </Button>
            <OnlineAvailabilityDialog user={user.name} open={openDialog} onClose={() => setOpenDialog(false)}
                                      editable={false} onlineAvailability={user.onlineAvailability ? user.onlineAvailability : ""}
            />
                        </span>
        </Tooltip>
    );
}
export default OnlineAvailabilityButton;